import { render, staticRenderFns } from "./UserDeleteConfirmDialog.vue?vue&type=template&id=280e4aed&scoped=true&"
import script from "./UserDeleteConfirmDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserDeleteConfirmDialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./UserDeleteConfirmDialog.vue?vue&type=style&index=0&id=280e4aed&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280e4aed",
  null
  
)

export default component.exports